import { LeaveModalAction } from "@abbvie-epi/common/enums";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
    selector: "app-leaving-site-modal",
    templateUrl: "./leaving-site-modal.component.html",
    styleUrls: ["./leaving-site-modal.component.scss"]
})
export class LeavingSiteModalComponent implements OnInit {
    @Input() public url: string;
    @Input() public continueLabel: string = "";
    public continueLabelString: string;

    public LeaveModalAction = LeaveModalAction;

    @Output() public modalClose = new EventEmitter<LeaveModalAction>();

    constructor() {}

    ngOnInit(): void {
        if (this.continueLabel) {
            this.getcontinueLabelString();
        }
    }

    private getcontinueLabelString() {
        if (this.continueLabel) {
            this.continueLabelString = this.continueLabel;
        }
    }
}
